import { useEffect } from 'react';

type SeoInput = {
  title: string;
  description: string;
};

export function useSeo({ title, description }: SeoInput) {
  useEffect(() => {
    const fullTitle = title.includes('JUST SEE') ? title : `${title} - JUST SEE LTD`;
    document.title = fullTitle;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);
}
